module.exports = __webpack_public_path__ + "img/gme_goldmandiotk.e1b3afb.png";